<template>
  <div>
    <MainNavBar />
    <Hero :hero="heroProductivity" />
    <SectionProjects />
    <SectionDocuments />
    <SectionIntelligentPDF />
    <section-search />
    <section-own-your-data />
    <section-more-secure />
    <CallToAction :content="productivityCTA" />
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import SectionProjects from '@/components/section-projects.vue';
import SectionDocuments from '@/components/section-documents.vue';
import SectionIntelligentPDF from '@/components/section-intelligent-pdf.vue';
import SectionSearch from '@/components/section-search.vue';
import SectionOwnYourData from '@/components/section-own-your-data.vue';
import SectionMoreSecure from '@/components/section-more-secure.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
export default {
  name: 'Productivity',
  components: {
    MainNavBar,
    Hero,
    Section,
    SectionProjects,
    SectionDocuments,
    SectionIntelligentPDF,
    SectionSearch,
    SectionOwnYourData,
    SectionMoreSecure,
    CallToAction,
    GmxFooter,
  },
  data() {
    return { 
      heroProductivity: { 
        eyebrowIcon: 'trinity.png',
        eyebrowTitle: 'Productivity',
        eyebrowSubtitle: 'Productivity Solid Server and Apps',
        header: 'IntelligentPDF',
        subheader: 'A single source of truth where all collaborators and apps share information.',
        img: 'hero-intelligentPDF.png',
        videoId: '686343471',
        buttons: [
          { label: 'Projects', path: '', id: 'projects' },
          { label: 'Documents', path: '', id: 'documents' },
          { label: 'IntelligentPDF\u2122', path: '', id: 'intelligent-pdf' },
          { label: 'TrinPod\u2122', path: '', id: 'own-your-data' },
        ]
      },
      /*projects: { 
        header: 'TrinApp\u2122 Projects',
        headerIcon: 'trinapp_projects.png',
        id: 'projects',
        listOneTitle: 'What it does for you',
        listOneBullets: [
          { text: 'Collaborate and manage projects in decentralized, Solid compliant storage.' },
          { text: 'Search across hundreds of projects each containing thousands of documents.' }
        ],
        listTwoTitle: 'What it does better',
        listTwoBullets: [
          { text: 'Find the information you need to take action in seconds.' },
          { text: 'State-of-the-art Security.' },
          { text: 'High Performance with any number of projects, each with any number of documents and any amount of data.' },
          { text: '100% ownership and control of your data.' },
          { text: 'Detailed access control, version control, history.' },
          { text: 'Your project data is free from apps that create silos. Share the data with any Solid compliant app.' },
        ],
        image: 'project-pods.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad'
      },
      intelligentPDF: { 
        header: 'IntelligentPDF\u2122',
        headerIcon: 'icon-ipdf.png',
        id: 'intelligent-pdf',
        listOneTitle: 'What it does for you',
        listOneBullets: [
          { text: 'Our conceptual AI Trinity reads your PDFs for you and transforms them into intelligentPDFs.' },
          { 
            text: 'The IntelligentPDF\u2122 contains a database with the content of the file:',
            /*nested: [
              { text: 'nested item 1.' },
              { text: 'nested item 2.' }
            ]
          }
        ],*/
        /*listOneNested: [
          { text: 'Structured into sections, single pages & sheets.' },
          { text: 'Each page/sheet contains its Units-of-Thought in space/time.' },
          { text: 'Finds and adds Hyperlinks between sheets.' },
          { text: 'Finds and adds Metadata, like discipline for each sheet.' }
        ],
        listTwoTitle: 'What it does better',
        listTwoBullets: [
          { text: 'Saves you time by reading the documents for you.' },
          { text: 'Search finds precisely what you need.' },
          { text: 'On building site using mobile.' }
        ],
        listTwoNested: [
          { text: 'Search across thousands of documents.' },
          { text: 'From documents containing thousands of pages and sheets, quick download the one single sheet where the information you need is located.' },
          { text: 'Instant navigation between referenced sheets.' }
        ],
        videoId: 686343471,
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad'
      },
      documents: { 
        header: 'TrinApp\u2122 Documents',
        headerIcon: 'trinapp_cde.png',
        id: 'documents',
        listOneTitle: 'What it does for you',
        listOneBullets: [
          { text: 'Manage and collaborate on all documents.' },
          { text: 'Read PDF documents and store the Units-of-Thought to your TrinPod\u2122.' },
        ],
        listTwoTitle: 'What it does better',
        listTwoBullets: [
          { text: 'Unlimited Free Users and collaborators.' },
          { text: 'Detailed access control.' },
          { text: 'Single Master Version.' },
          { text: 'Organize documents in TrinPods\u2122 representing the Business, Building or Project they are related to.' },
          { text: 'Finding documents and information inside your documents becomes a breeze.' },
        ],
        image: 'trinapp-documents.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad'
      },
      trinpod: { 
        header: 'TrinPod\u2122',
        headerIcon: 'trinity_secure.png',
        id: 'trinpod',
        listOneTitle: 'What it does for you',
        listOneBullets: [
          { text: 'Store your information in a graph database with Trinity for conceptual AI on decentralized industrial-strength Solid Pods with collaboration across the supply chain.' }
        ],
        listTwoTitle: 'What it does better',
        listTwoBullets: [
          { text: 'Your company 100% owns and controls your data.' },
          { text: 'Maximum security.' },
          { text: 'High performance handling a massive amount of information with future proof flexibility.' },
          { text: 'Your data is not siloed into vendors apps.' },
        ],
        image: 'trinity_secure.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad'
      },*/
      productivityCTA: {
        header: 'Start using TrinPod\u2122',
        bgClass: 'bg-neon-blue-grad',
        btnText: 'Contact us',
        btnVariant: 'turquoise'
      }
    }
  }
};
</script>

<!--style>
html {
  scroll-behavior: smooth;
}
</style-->
